/** Quick add (spec page 2c) - title, requester, division; details later. */
import { useState } from 'react';
import { TYPES, type DivisionId, type RequestType } from '../config';
import { createRequest, type Me } from '../lib/data';
import { DivisionPicker } from '../ui';

export function QuickAdd({ me, onClose, onCreated }: { me: Me; onClose: () => void; onCreated: (id: string) => void }) {
  const [title, setTitle] = useState('');
  const [who, setWho] = useState('');
  const [type, setType] = useState<RequestType>('support');
  const [divisions, setDivisions] = useState<DivisionId[]>([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function add(e: React.FormEvent) {
    e.preventDefault();
    if (!title.trim()) return;
    setBusy(true); setErr(null);
    try {
      const ref = await createRequest(me, { title, requesterName: who || me.name, divisions, type });
      onCreated(ref.id);
    } catch (x) { setErr((x as Error).message); setBusy(false); }
  }

  return (
    <div className="overlay" onClick={onClose}>
      <form className="card modal" onClick={(e) => e.stopPropagation()} onSubmit={add}>
        <h2>Quick add</h2>
        <input autoFocus value={title} onChange={(e) => setTitle(e.target.value)} placeholder="What's the ask?" maxLength={300} />
        <div className="row-2">
          <input value={who} onChange={(e) => setWho(e.target.value)} placeholder="Who asked? (blank = you)" />
          <select value={type} onChange={(e) => setType(e.target.value as RequestType)}>
            {TYPES.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
          </select>
        </div>
        <DivisionPicker value={divisions} onChange={setDivisions} />
        <p className="muted small">No division picked = Company-wide. Lands in New.</p>
        <div className="actions">
          <button type="button" className="secondary" onClick={onClose}>Cancel</button>
          <button type="submit" disabled={busy || !title.trim()}>{busy ? 'Adding...' : 'Add'}</button>
        </div>
        {err && <p className="err">{err}</p>}
      </form>
    </div>
  );
}
